"use strict";

var _interopRequireDefault = require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es7.object.get-own-property-descriptors");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es7.array.includes");

var _slicedToArray2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/slicedToArray.js"));

require("core-js/modules/es7.object.entries");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.array.find");

require("core-js/modules/es6.array.sort");

require("core-js/modules/es6.object.keys");

require("core-js/modules/web.dom.iterable");

var _toConsumableArray2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/toConsumableArray.js"));

var _defineProperty2 = _interopRequireDefault(require("D:/CRM/Client2026/node_modules/@babel/runtime/helpers/defineProperty.js"));

var _contract = require("@/api/cms/contract");

var _cmsWorkOrder = require("@/api/cmsWorkOrder");

var _order = require("@/api/cms/order");

var _ossUpload = require("@/api/cms/ossUpload");

var _commonUpload = _interopRequireDefault(require("@/views/cms/common/commonUpload"));

var _auth = require("@/utils/auth");

var _vuex = require("vuex");

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }

function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

var _default = {
  name: 'ModifySupplementList',
  components: {
    CommonUpload: _commonUpload.default
  },
  dicts: ['after_productionstatus_total', 'after_problem_type'],
  data: function data() {
    return {
      headers: {
        'Authorization': (0, _auth.getToken)()
      },
      loading: false,
      showMoreSearch: false,
      selectedStatus: '全部',
      // 从首页带入的待处理改补订单 auditIds（逗号分隔）
      auditIds: '',
      searchForm: {
        productionOrder: '',
        contractNo: '',
        originalContractNo: '',
        name: '',
        mobile: '',
        address: '',
        questionType: '',
        problemCause: '',
        problemNow: '',
        storeName: '',
        productionStatus: '',
        // contractAfter 搜索字段
        amendmentType: '',
        subStatus: '',
        // 处理人 / 接单人
        assignNickName: '',
        orderNickName: '',
        // 设计师 / 发起改补人
        designerNickName: '',
        afterCreateUserName: ''
      },
      createDateRange: null,
      // 处理时间范围（orderTimeBegin / orderTimeTimeEnd）
      orderTimeRange: null,
      contractList: [],
      statusCounts: {},
      // 状态统计 { '全部': 10, '已签单': 5, ... }
      currentPage: 1,
      pageSize: 10,
      total: 0,
      // 表格多选
      multipleSelection: [],
      // 物料查看弹窗
      showMaterialDialog: false,
      materialLoading: false,
      materialTab: 'original',
      materialOriginalList: [],
      materialOtherList: [],
      materialKujialeList: [],
      // 批量取消弹窗
      showCancelDialog: false,
      cancelForm: {
        orderNo: '',
        contractId: '',
        contractNo: '',
        custName: '',
        custAddress: '',
        orderDate: '',
        orderApprovalDate: '',
        plannedDeliveryDate: '',
        applyDate: '',
        applyReason: '',
        urgentAfterReorder: '',
        remark: '',
        productionOrders: []
      },
      cancelFiles: [],
      batchCancelLoading: false,
      // 确认付款弹窗
      showPayDialog: false,
      payLoading: false,
      paySubmitting: false,
      payContractId: '',
      payContractNo: '',
      // 改补信息ID（subPay 接口需要的 rowId）
      payRowId: '',
      payInfo: {
        payNickName: '',
        payTime: '',
        chargeAmount: null,
        paymentProof: '',
        payRemark: ''
      },
      paymentProofUploadList: [],
      uploadPaymentProofs: [],
      // 付款凭证上传中标记
      payProofUploading: false,
      // 付款二维码
      showPayQrDialog: false,
      payQrUrl: 'https://oss.aiggf.cn/upload/image/eebd26f4a5964818a59efbd709ccca71.png',
      // 报价信息
      showQuoteDialog: false,
      quoteLoading: false,
      quoteList: [],
      quoteTotal: 0,
      exportLoading: false,
      showExportDialog: false,
      exportSelectedFields: [],
      exportSelectAll: false,
      configDialogVisible: false,
      originalHeaderConfig: [],
      tableHeader: [{
        key: 'productionOrder',
        label: '订单号',
        visible: true,
        minWidth: 140
      }, {
        key: 'originalOrderNumber',
        label: '原单号',
        visible: true,
        minWidth: 160
      }, {
        key: 'contractNo',
        label: '合同号',
        visible: true,
        minWidth: 160
      }, {
        key: 'originalContractNo',
        label: '原合同号',
        visible: true,
        minWidth: 140
      }, {
        key: 'auditName',
        label: '产品名称',
        visible: true,
        minWidth: 160
      }, {
        key: 'productionStatus',
        label: '订单状态',
        visible: true,
        minWidth: 100
      }, {
        key: 'custName',
        label: '客户名称',
        visible: true,
        minWidth: 120
      }, {
        key: 'custMobile',
        label: '客户电话',
        visible: true,
        minWidth: 120
      }, {
        key: 'custAddress',
        label: '客户地址',
        visible: true,
        minWidth: 160
      }, {
        key: 'dealerShopName',
        label: '经销商',
        visible: true,
        minWidth: 120
      }, {
        key: 'contractStatusEnumeration',
        label: '合同状态',
        visible: true,
        minWidth: 100
      }, {
        key: 'storeName',
        label: '门店',
        visible: true,
        minWidth: 120
      }, {
        key: 'guideNickName',
        label: '导购',
        visible: true,
        minWidth: 100
      }, {
        key: 'designerNickName',
        label: '设计师',
        visible: true,
        minWidth: 100
      }, {
        key: 'createUserName',
        label: '下单人',
        visible: true,
        minWidth: 100
      }, {
        key: 'createTime',
        label: '下单时间',
        visible: true,
        minWidth: 160
      }, {
        key: 'amount',
        label: '合同金额',
        visible: true,
        minWidth: 120
      }, {
        key: 'type',
        label: '合同类型',
        visible: false,
        minWidth: 100
      }, {
        key: 'signingTime',
        label: '签单时间',
        visible: false,
        minWidth: 160
      }, // ---- 改补数据 (contractAfter) ----
      {
        key: 'afterAmendmentType',
        label: '改补类型',
        visible: true,
        minWidth: 100
      }, {
        key: 'afterSubStatus',
        label: '提交状态',
        visible: true,
        minWidth: 100
      }, {
        key: 'afterCreateTime',
        label: '发起改补时间',
        visible: true,
        minWidth: 160
      }, {
        key: 'afterCreateUserName',
        label: '发起改补人',
        visible: true,
        minWidth: 110
      }, {
        key: 'afterProblemCause',
        label: '问题原因',
        visible: true,
        minWidth: 140
      }, {
        key: 'afterProblemNow',
        label: '问题现状',
        visible: true,
        minWidth: 140
      }, {
        key: 'afterAssignNickName',
        label: '处理人',
        visible: false,
        minWidth: 110
      }, {
        key: 'afterOrderTime',
        label: '处理时间',
        visible: true,
        minWidth: 160
      }, {
        key: 'afterOrderNickName',
        label: '接单人',
        visible: false,
        minWidth: 110
      }, {
        key: 'afterQuestionType',
        label: '问题类型',
        visible: false,
        minWidth: 100
      }, {
        key: 'afterProblemDescription',
        label: '问题描述',
        visible: false,
        minWidth: 200
      }, {
        key: 'afterAuditRemark',
        label: '审核备注',
        visible: false,
        minWidth: 140
      }, {
        key: 'afterContactPerson',
        label: '改补联系人',
        visible: false,
        minWidth: 110
      }, {
        key: 'afterContactNumber',
        label: '改补联系电话',
        visible: false,
        minWidth: 130
      }, {
        key: 'afterContactAddress',
        label: '改补联系地址',
        visible: false,
        minWidth: 200
      }, {
        key: 'afterRequiredInboundTime',
        label: '要求入库时间',
        visible: false,
        minWidth: 160
      }, {
        key: 'afterRequiredDeliveryDate',
        label: '要求到货日期',
        visible: false,
        minWidth: 160
      }, {
        key: 'afterRequiredInstallationDate',
        label: '要求安装日期',
        visible: false,
        minWidth: 160
      }, {
        key: 'afterDeliveryPhase',
        label: '交付阶段',
        visible: false,
        minWidth: 100
      }, {
        key: 'afterChargedAmount',
        label: '收费金额',
        visible: false,
        minWidth: 100
      }, {
        key: 'afterJudgmentTime',
        label: '初判时间',
        visible: false,
        minWidth: 160
      }, {
        key: 'afterDrawingReviewTime',
        label: '审图时间',
        visible: false,
        minWidth: 160
      }, {
        key: 'afterQuotationTime',
        label: '报价时间',
        visible: false,
        minWidth: 160
      }, {
        key: 'afterDealerConfirmationTime',
        label: '经销商确认时间',
        visible: false,
        minWidth: 160
      }, {
        key: 'afterProductionScheduleTime',
        label: '生产计划时间',
        visible: false,
        minWidth: 160
      }, {
        key: 'afterSchedulingTime',
        label: '排产时间',
        visible: false,
        minWidth: 160
      }, {
        key: 'afterStartProductionTime',
        label: '开始生产时间',
        visible: false,
        minWidth: 160
      }, {
        key: 'afterDeliveryDeadlineTime',
        label: '交货期限',
        visible: false,
        minWidth: 160
      }, {
        key: 'afterWarehousingTime',
        label: '入库时间',
        visible: false,
        minWidth: 160
      }, {
        key: 'afterOutboundTime',
        label: '出库时间',
        visible: false,
        minWidth: 160
      }, {
        key: 'afterChangeStatus',
        label: '改补状态',
        visible: false,
        minWidth: 100
      }, {
        key: 'afterServiceRemark',
        label: '跟进备注',
        visible: false,
        minWidth: 160
      }]
    };
  },
  computed: _objectSpread(_objectSpread({}, (0, _vuex.mapGetters)(['filesUploadApi'])), {}, {
    // 确认付款模块是否允许操作：仅合同状态86（待经销商确认）且未付款（付款时间为空）时可操作
    canEditPay: function canEditPay() {
      return !!this.payInfo && !this.payInfo.payTime;
    },
    visibleColumns: {
      get: function get() {
        return this.tableHeader.filter(function (col) {
          return col.visible;
        });
      },
      set: function set(val) {
        this.tableHeader = [].concat((0, _toConsumableArray2.default)(val), (0, _toConsumableArray2.default)(this.tableHeader.filter(function (col) {
          return !col.visible;
        })));
      }
    }
  }),
  mounted: function mounted() {
    var _this = this;

    // 支持从首页携带 auditIds（待处理改补订单 ID 列表）进入；从其他页面进入时清空
    this.auditIds = this.$route.query && this.$route.query.auditIds || '';
    this.handleSearch();
    this.loadHeaderConfig();
    this.$on('dictReady', function () {
      _this.loadStatusCounts();
    });
  },
  watch: {
    // 监听路由变化：组件被缓存复用时，重新同步 auditIds 并加载数据
    $route: {
      handler: function handler(val) {
        var auditIds = val.query && val.query.auditIds || '';

        if (auditIds !== this.auditIds) {
          this.auditIds = auditIds;
          this.currentPage = 1;
          this.handleSearch();
        }
      },
      immediate: false
    },
    tableHeader: {
      handler: function handler() {
        this.$forceUpdate();
      },
      deep: true
    }
  },
  methods: {
    // 清除 auditIds 过滤，查看全部
    clearAuditIds: function clearAuditIds() {
      this.auditIds = '';
      this.currentPage = 1;
      this.handleSearch();
    },
    // 搜索按钮点击（重置到第一页）
    handleSearchClick: function handleSearchClick() {
      this.currentPage = 1;
      this.handleSearch();
    },
    // 搜索
    handleSearch: function handleSearch() {
      var _this2 = this;

      this.loading = true;
      var params = this.buildSearchParams();
      (0, _contract.queryModifySupplementV2)(params).then(function (response) {
        if (response.code === 200 && response.data) {
          var content = response.data.content || []; // 将嵌套的 audit + contract + contractAfter 展平为单层数据

          _this2.contractList = content.map(function (item) {
            var contract = item.contract || {};
            var audit = item.audit || {};
            var contractAfter = item.contractAfter || {}; // 扁平化 contractAfter 字段，加 after 前缀避免命名冲突

            var afterFields = {};
            Object.keys(contractAfter).forEach(function (key) {
              afterFields['after' + key.charAt(0).toUpperCase() + key.slice(1)] = contractAfter[key];
            });

            var flat = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, contract), audit), afterFields), {}, {
              // 合同状态编码兜底：后端可能返回 status / contractStatusEnumeration，统一补上 contractStatus
              contractStatus: contract.contractStatus != null ? contract.contractStatus : contract.status != null ? contract.status : contract.contractStatusEnumeration === '待经销商确认' ? 86 : contract.contractStatus,
              // 保留原始嵌套对象方便弹窗使用
              _contract: contract,
              _audit: audit,
              _contractAfter: contractAfter,
              rowId: audit.rowId || contract.id
            });

            return flat;
          });
          _this2.total = response.data.totalElements || 0;
        } else {
          _this2.$message.error(response.msg || '查询失败');

          _this2.contractList = [];
        }
      }).catch(function (error) {
        console.error('查询失败:', error);

        _this2.$message.error('网络错误，请稍后重试');

        _this2.contractList = [];
      }).finally(function () {
        _this2.loading = false;
      });
      this.loadStatusCounts();
    },
    // 加载状态统计
    loadStatusCounts: function loadStatusCounts() {
      var _this3 = this;

      var params = this.buildSearchParams();
      delete params.page;
      delete params.size;
      delete params.sort;
      delete params.productionStatus;
      (0, _order.statProductionStatusTotal)(params).then(function (response) {
        if (response.code === 200 && response.data) {
          _this3.$set(_this3, 'statusCounts', response.data);
        }
      }).catch(function () {});
    },
    // 构建搜索参数
    // 点击状态筛选
    handleStatusClick: function handleStatusClick(status) {
      this.selectedStatus = status;
      this.searchForm.productionStatus = status === '全部' ? '' : status;
      this.currentPage = 1;
      this.handleSearch();
    },
    // 获取标签类型
    getTagType: function getTagType(status) {
      var typeMap = {
        '待生产': 'warning',
        '生产中': '',
        '生产完成': 'success',
        '已发货': 'info'
      };
      return typeMap[status] || 'primary';
    },
    // 获取状态计数
    getStatusCount: function getStatusCount(value) {
      try {
        var dictItem = this.dict.after_productionstatus_total.find(function (item) {
          return item.value === value;
        });

        if (dictItem && dictItem.unit && this.statusCounts && this.statusCounts[dictItem.unit] !== undefined) {
          return this.statusCounts[dictItem.unit] || 0;
        }
      } catch (e) {}

      return 0;
    },
    buildSearchParams: function buildSearchParams() {
      var params = {};
      if (this.auditIds) params.auditIds = this.auditIds;
      if (this.searchForm.contractNo) params.contractNo = this.searchForm.contractNo;
      if (this.searchForm.originalContractNo) params.originalContractNo = this.searchForm.originalContractNo;
      if (this.searchForm.name) params.name = this.searchForm.name;
      if (this.searchForm.mobile) params.mobile = this.searchForm.mobile;
      if (this.searchForm.address) params.address = this.searchForm.address;
      if (this.searchForm.storeName) params.storeName = this.searchForm.storeName;
      if (this.searchForm.productionStatus) params.productionStatus = this.searchForm.productionStatus;
      if (this.searchForm.questionType) params.questionType = this.searchForm.questionType;
      if (this.searchForm.problemCause) params.problemCause = this.searchForm.problemCause;
      if (this.searchForm.problemNow) params.problemNow = this.searchForm.problemNow;
      if (this.searchForm.amendmentType) params.amendmentType = this.searchForm.amendmentType;
      if (this.searchForm.subStatus) params.subStatus = this.searchForm.subStatus;

      if (this.createDateRange && this.createDateRange.length === 2) {
        params.createDateBegin = this.createDateRange[0];
        params.createDateEnd = this.createDateRange[1];
      } // 处理人 / 接单人


      if (this.searchForm.assignNickName) params.assignNickName = this.searchForm.assignNickName;
      if (this.searchForm.orderNickName) params.orderNickName = this.searchForm.orderNickName; // 设计师 / 发起改补人

      if (this.searchForm.designerNickName) params.designerNickName = this.searchForm.designerNickName;
      if (this.searchForm.afterCreateUserName) params.afterCreateUserName = this.searchForm.afterCreateUserName; // 处理时间范围（注意后端结束字段名为 orderTimeTimeEnd）

      if (this.orderTimeRange && this.orderTimeRange.length === 2) {
        params.orderTimeBegin = this.orderTimeRange[0];
        params.orderTimeTimeEnd = this.orderTimeRange[1];
      }

      params.page = this.currentPage - 1;
      params.size = this.pageSize;
      if (this.searchForm.productionOrder) params.productionOrder = this.searchForm.productionOrder;
      params.sort = 'createTime,desc';
      return params;
    },
    // 重置搜索
    resetSearch: function resetSearch() {
      this.searchForm = {
        productionOrder: '',
        contractNo: '',
        originalContractNo: '',
        name: '',
        problemCause: '',
        problemNow: '',
        mobile: '',
        address: '',
        questionType: '',
        storeName: '',
        productionStatus: '',
        amendmentType: '',
        subStatus: '',
        assignNickName: '',
        orderNickName: '',
        designerNickName: '',
        afterCreateUserName: ''
      };
      this.selectedStatus = '全部';
      this.createDateRange = null;
      this.orderTimeRange = null;
      this.showMoreSearch = false;
      this.currentPage = 1;
      this.handleSearch();
    },
    // 导出：打开字段选择弹窗（显示所有列配置，默认全选）
    openExportDialog: function openExportDialog() {
      this.exportSelectedFields = this.tableHeader.map(function (h) {
        return h.key;
      });
      this.exportSelectAll = true;
      this.showExportDialog = true;
    },
    toggleExportSelectAll: function toggleExportSelectAll(val) {
      if (val) {
        this.exportSelectedFields = this.tableHeader.map(function (h) {
          return h.key;
        });
      } else {
        this.exportSelectedFields = [];
      }
    },
    confirmExport: function confirmExport() {
      var _this4 = this;

      if (!this.exportSelectedFields || this.exportSelectedFields.length === 0) {
        this.$message.warning('请先选择要导出的字段');
        return;
      }

      this.exportLoading = true;
      var criteria = this.buildSearchParams();
      var searchParams = new URLSearchParams();
      Object.keys(criteria || {}).forEach(function (key) {
        var val = criteria[key];
        if (val === undefined || val === null || val === '') return;

        if (Array.isArray(val)) {
          val.forEach(function (v) {
            return searchParams.append(key, v);
          });
        } else {
          searchParams.append(key, val);
        }
      });
      this.exportSelectedFields.forEach(function (f) {
        return searchParams.append('exportFields', f);
      });
      this.$message({
        message: '导出中，请稍候...',
        duration: 0
      });
      (0, _contract.downloadCS)(searchParams).then(function (blob) {
        var url = window.URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url;
        var filename = '改补数据_' + new Date().toISOString().slice(0, 19).replace(/[:T]/g, '-') + '.xlsx';
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
        _this4.showExportDialog = false;

        _this4.$message.closeAll();

        _this4.$message.success('导出完成');
      }).catch(function (err) {
        _this4.$message.closeAll();

        _this4.$message.error('导出失败');

        console.error('导出失败:', err);
      }).finally(function () {
        _this4.exportLoading = false;
      });
    },
    // 列配置：加载已保存的配置
    loadHeaderConfig: function loadHeaderConfig() {
      var _this5 = this;

      if (!this.tableHeader || this.tableHeader.length === 0) return;
      var savedConfig = localStorage.getItem('modifySupplementHeaderConfig');

      if (savedConfig) {
        try {
          var config = JSON.parse(savedConfig);
          config.forEach(function (item) {
            var col = _this5.tableHeader.find(function (col) {
              return col.key === item.key;
            });

            if (col) {
              col.visible = item.visible;
            }
          });
        } catch (e) {
          console.error('加载列配置失败:', e);
        }
      }
    },
    // 切换列显示/隐藏
    toggleColumnVisible: function toggleColumnVisible(key) {
      var col = this.tableHeader.find(function (c) {
        return c.key === key;
      });

      if (col) {
        col.visible = !col.visible;
      }
    },
    // 全部隐藏
    moveAllToLeft: function moveAllToLeft() {
      this.tableHeader.forEach(function (col) {
        col.visible = false;
      });
    },
    // 全部显示
    moveAllToRight: function moveAllToRight() {
      this.tableHeader.forEach(function (col) {
        col.visible = true;
      });
    },
    // 打开列配置弹窗
    openConfigDialog: function openConfigDialog() {
      this.originalHeaderConfig = this.tableHeader.map(function (col) {
        return {
          key: col.key,
          visible: col.visible
        };
      });
      this.configDialogVisible = true;
    },
    // 保存列配置
    saveHeaderConfig: function saveHeaderConfig() {
      var config = this.tableHeader.map(function (col) {
        return {
          key: col.key,
          visible: col.visible
        };
      });
      localStorage.setItem('modifySupplementHeaderConfig', JSON.stringify(config));
      this.configDialogVisible = false;
      this.$message.success('列配置已保存');
    },
    // 重置列配置
    resetHeaderConfig: function resetHeaderConfig() {
      this.tableHeader.forEach(function (col) {
        col.visible = true;
      });
    },
    // 分页
    handleSizeChange: function handleSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1;
      this.handleSearch();
    },
    handleCurrentChange: function handleCurrentChange(current) {
      this.currentPage = current;
      this.handleSearch();
    },
    // 表格多选变化
    handleSelectionChange: function handleSelectionChange(rows) {
      this.multipleSelection = rows;
    },
    // 解析昵称字段 (JSON数组)
    parseNickName: function parseNickName(val) {
      if (!val) return '';

      try {
        var arr = typeof val === 'string' ? JSON.parse(val) : val;
        return Array.isArray(arr) ? arr.join(', ') : val;
      } catch (_unused) {
        return val;
      }
    },
    // 查看合同 - 显示改补信息
    handleViewContract: function handleViewContract(row) {
      var contract = row._contract || row;
      var query = new URLSearchParams({
        id: contract.id || '',
        contractNo: contract.contractNo || '',
        originalContractNo: contract.originalContractNo || '',
        custName: contract.custName || '',
        custMobile: contract.custMobile || '',
        custAddress: contract.custAddress || '',
        province: contract.province || '',
        city: contract.city || '',
        district: contract.district || '',
        orderClerkNickName: contract.orderClerkNickName || '',
        designerNickName: contract.designerNickName || '',
        guideNickName: contract.guideNickName || '',
        dealerShopName: contract.dealerShopName || '',
        storeName: contract.storeName || '',
        msgFrom: contract.msgFrom || '',
        channelType: contract.channelType || '',
        installMamager: contract.installMamager || '',
        installGroup: contract.installGroup || '',
        installPerson: contract.installPerson || '',
        installFinishTime: contract.installFinishTime || '',
        actualFinishingDate: contract.actualFinishingDate || '',
        submitUser: contract.submitUser || '',
        signingTime: contract.signingTime || '',
        createdatetime: contract.createdatetime || ''
      });
      this.$router.push("/cms/modifySupplement/detail?".concat(query));
    },
    // 点击订单号查看物料
    handleViewMaterials: function handleViewMaterials(row) {
      var _this6 = this;

      var contractNo = row.contractNo;

      if (!contractNo) {
        this.$message.warning('缺少合同号');
        return;
      }

      this.materialTab = 'original';
      this.materialOriginalList = [];
      this.materialOtherList = [];
      this.materialKujialeList = [];
      this.materialLoading = true;
      this.showMaterialDialog = true;
      (0, _order.queryByContractId)({
        contractNo: contractNo
      }).then(function (response) {
        if (response.code === 200 && response.data) {
          _this6.materialOriginalList = response.data.originalList || [];
          _this6.materialOtherList = response.data.otherList || [];
          _this6.materialKujialeList = response.data.KuJiaLeList || [];
        }
      }).catch(function () {
        _this6.$message.error('加载物料失败');
      }).finally(function () {
        _this6.materialLoading = false;
      });
    },
    // 按 productionOrder 对物料进行分组
    groupByProductionOrder: function groupByProductionOrder(list) {
      var groups = {};
      list.forEach(function (item) {
        var key = item.productionOrder || '__无单号__';
        if (!groups[key]) groups[key] = [];
        groups[key].push(item);
      });
      return Object.entries(groups).map(function (_ref) {
        var _ref2 = (0, _slicedToArray2.default)(_ref, 2),
            productionOrder = _ref2[0],
            items = _ref2[1];

        return {
          productionOrder: productionOrder,
          items: items
        };
      });
    },
    // 跳转到酷家乐下单
    handleOrderContract: function handleOrderContract(row) {
      var contract = row._contract || row;
      this.$router.push("/orders/create?contractNo=".concat(contract.contractNo || '', "&contractId=").concat(contract.id || '', "&originalContractNo=").concat(contract.originalContractNo || ''));
    },
    // 取消销售单 — 打开弹窗
    handleAuditBatchCancel: function handleAuditBatchCancel(row) {
      var productionOrder = row.productionOrder;

      if (!productionOrder) {
        this.$message.warning('该记录没有销售单号');
        return;
      }

      var contract = row._contract || row;
      var contractId = contract.id || row.contractId || '';

      if (!contractId) {
        this.$message.warning('该记录缺少合同ID，无法取消');
        return;
      }

      this.cancelForm = {
        orderNo: productionOrder,
        contractId: contractId,
        contractNo: row.contractNo || contract.contractNo || '',
        custName: row.custName || contract.custName || '',
        custAddress: row.custAddress || contract.custAddress || '',
        orderDate: row.createTime ? String(row.createTime).slice(0, 10) : '',
        orderApprovalDate: '',
        plannedDeliveryDate: '',
        applyDate: new Date().toISOString().slice(0, 10),
        applyReason: '',
        urgentAfterReorder: '',
        remark: '',
        productionOrders: [productionOrder]
      };
      this.cancelFiles = [];

      if (this.$refs.cancelFileUpload) {
        this.$refs.cancelFileUpload.clearImgs();
      }

      this.showCancelDialog = true;
    },
    // 确认批量取消
    confirmBatchCancel: function confirmBatchCancel() {
      var _this7 = this;

      var form = this.cancelForm;

      if (!form.applyDate || !form.applyReason || !form.urgentAfterReorder) {
        this.$message.error('请填写必填信息');
        return;
      }

      this.batchCancelLoading = true;
      var params = {
        contractIds: [form.contractId],
        contractNo: form.contractNo,
        custName: form.custName,
        custAddress: form.custAddress,
        orderDate: form.orderDate,
        orderApprovalDate: form.orderApprovalDate || '',
        plannedDeliveryDate: form.plannedDeliveryDate || '',
        applyDate: form.applyDate,
        applyReason: form.applyReason,
        remark: form.remark,
        urgentAfterReorder: form.urgentAfterReorder,
        productionOrders: form.productionOrders
      };

      if (this.cancelFiles && this.cancelFiles.length > 0) {
        params.files = this.cancelFiles;
      }

      (0, _order.afterSales)(params).then(function (response) {
        if (response.code === 200) {
          _this7.$message.success('取消成功');

          _this7.showCancelDialog = false;
          _this7.multipleSelection = [];
          _this7.cancelFiles = [];

          if (_this7.$refs.cancelFileUpload) {
            _this7.$refs.cancelFileUpload.clearImgs();
          }

          _this7.handleSearch();
        } else {
          _this7.$message.error(response.msg || '批量取消失败');
        }
      }).catch(function (error) {
        console.error('批量取消失败:', error);

        _this7.$message.error('网络错误，请稍后重试');
      }).finally(function () {
        _this7.batchCancelLoading = false;
      });
    },
    // 取消弹窗附件上传成功
    handleCancelFileUpload: function handleCancelFileUpload(filePaths) {
      var _this8 = this;

      this.cancelFiles = [];
      filePaths.forEach(function (filePath) {
        try {
          var fileObj = JSON.parse(filePath);

          _this8.cancelFiles.push(fileObj);
        } catch (e) {
          console.error('解析文件数据失败:', e);
        }
      });
    },
    // 取消弹窗附件删除成功
    handleCancelFileDelete: function handleCancelFileDelete(filePaths) {
      var _this9 = this;

      this.cancelFiles = [];

      if (filePaths && filePaths.length > 0) {
        filePaths.forEach(function (filePath) {
          try {
            var fileObj = JSON.parse(filePath);

            _this9.cancelFiles.push(fileObj);
          } catch (e) {
            console.error('解析文件数据失败:', e);
          }
        });
      }
    },
    // 点击合同号 - 查看详情
    handleContractClick: function handleContractClick(row) {
      this.handleViewContract(row);
    },
    // 同步合同
    handleSyncContract: function handleSyncContract(contract) {
      var _this10 = this;

      this.$confirm("\u786E\u8BA4\u540C\u6B65\u5408\u540C ".concat(contract.contractNo, " \u7684\u6700\u65B0\u72B6\u6001\u5417\uFF1F"), '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _contract.manualSyncByContract)(contract.contractNo).then(function (res) {
          if (res.code === 200) {
            _this10.$message.success('同步成功');

            _this10.handleSearch();
          } else {
            _this10.$message.error(res.msg || '同步失败');
          }
        }).catch(function () {
          _this10.$message.error('同步失败，请稍后重试');
        });
      }).catch(function () {});
    },
    // 编辑合同 - 跳转到编辑页面
    handleEditPage: function handleEditPage(row) {
      var contract = row._contract || row;
      var audit = row._audit || {};
      var query = new URLSearchParams({
        id: contract.id || '',
        afterId: audit.rowId || '',
        contractNo: contract.contractNo || '',
        originalContractNo: contract.originalContractNo || '',
        custName: contract.custName || '',
        custMobile: contract.custMobile || '',
        custAddress: contract.custAddress || '',
        province: contract.province || '',
        city: contract.city || '',
        district: contract.district || '',
        orderClerkNickName: contract.orderClerkNickName || '',
        designerNickName: contract.designerNickName || '',
        guideNickName: contract.guideNickName || '',
        dealerShopName: contract.dealerShopName || '',
        storeName: contract.storeName || '',
        msgFrom: contract.msgFrom || '',
        channelType: contract.channelType || '',
        installMamager: contract.installMamager || '',
        installGroup: contract.installGroup || '',
        installPerson: contract.installPerson || '',
        installFinishTime: contract.installFinishTime || '',
        actualFinishingDate: contract.actualFinishingDate || '',
        submitUser: contract.submitUser || '',
        signingTime: contract.signingTime || '',
        createdatetime: contract.createdatetime || '',
        contractStatus: contract.contractStatus != null ? contract.contractStatus : ''
      });
      this.$router.push("/cms/modifySupplement/edit?".concat(query));
    },
    // 删除合同
    handleDeleteContract: function handleDeleteContract(row) {
      var _this11 = this;

      var contractId = row._contract ? row._contract.id : row.id;
      this.$confirm('确定要删除该合同吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _cmsWorkOrder.delContract)([contractId]).then(function (response) {
          if (response && response.code === 200) {
            _this11.$message.success('删除成功');

            _this11.handleSearch();
          } else {
            _this11.$message.error(response.msg || '删除失败');
          }
        }).catch(function (error) {
          console.error('删除合同失败:', error);

          _this11.$message.error('网络错误，请稍后重试');
        });
      }).catch(function () {});
    },
    // 发起改补 - 跳转到新增页面
    handleCreateModifySupplement: function handleCreateModifySupplement() {
      this.$router.push('/cms/modifySupplement/create?fresh=1');
    },
    // === 确认付款（从列表直接操作） ===
    // 行是否可付款：订单状态为"待经销商确认"才显示（已付款也显示，供查看付款信息）
    canPayRow: function canPayRow(row) {
      var audit = row._audit || {}; // 订单状态优先取嵌套 audit，其次取展平后的行数据

      var productionStatus = audit.productionStatus != null ? audit.productionStatus : row.productionStatus; // 兼容数字编码 80（待经销商确认）和字符串"待经销商确认"

      return productionStatus === '待经销商确认';
    },
    // 行是否可取消：需有销售单号，且订单状态已进入可取消流程
    // （未提交需先下单，回退/退回/订单退回均可取消，已取消的不再重复取消）
    canCancelRow: function canCancelRow(row) {
      if (!row.productionOrder) return false;
      var audit = row._audit || {};
      var productionStatus = audit.productionStatus != null ? audit.productionStatus : row.productionStatus;
      var disabledStatuses = ['未提交', '取消', '已取消'];
      if (!productionStatus) return false;
      return !disabledStatuses.includes(productionStatus);
    },
    // 点击付款：打开弹窗并加载改补信息
    handlePay: function handlePay(row) {
      var contract = row._contract || row;
      var after = row._contractAfter || {};
      this.payContractId = contract.id || '';
      this.payContractNo = contract.contractNo || row.contractNo || ''; // 改补信息ID（优先用行内 contractAfter 的 id，弹窗打开时再拉取最新）

      this.payRowId = after.id || after.rowId || row.afterRowId || ''; // 预填充行内已有的付款信息（供回显），弹窗打开时再拉取最新数据

      this.payInfo = {
        payNickName: after.payNickName || '',
        payTime: after.payTime || '',
        chargeAmount: after.chargeAmount != null ? Number(after.chargeAmount) : null,
        paymentProof: after.paymentProof || '',
        payRemark: after.payRemark || ''
      };
      this.paymentProofUploadList = [];
      this.uploadPaymentProofs = [];
      this.showPayDialog = true;
    },
    // 弹窗打开时加载改补信息
    loadPayData: function loadPayData() {
      var _this12 = this;

      if (!this.payContractId) {
        this.$message.warning('缺少合同ID');
        return;
      }

      this.payLoading = true;
      (0, _contract.getContractAfterInfo)(this.payContractId).then(function (response) {
        if (response.code === 200 && response.data) {
          var data = response.data;
          var info = Array.isArray(data) ? data[0] || {} : data; // 用接口返回的改补信息ID（subPay 需要的 rowId）

          _this12.payRowId = info.id || info.rowId || _this12.payRowId;
          _this12.payInfo = {
            payNickName: info.payNickName || '',
            payTime: info.payTime || '',
            chargeAmount: info.chargeAmount != null ? Number(info.chargeAmount) : null,
            paymentProof: info.paymentProof || '',
            payRemark: info.payRemark || ''
          }; // 回显付款凭证到上传列表（仅在用户尚未上传新凭证时回显，避免覆盖刚上传的文件）

          if (_this12.uploadPaymentProofs.length === 0) {
            _this12.paymentProofUploadList = _this12.buildUploadList(info.paymentProof);
            _this12.uploadPaymentProofs = _this12.parseFiles(info.paymentProof).map(function (item) {
              return JSON.stringify(item);
            });
          } // 付款金额为空时，自动从报价接口获取总金额赋值（统计为0时也显示上去）


          if (_this12.payInfo.chargeAmount == null) {
            var contractNo = _this12.payContractNo;

            if (contractNo) {
              (0, _contract.getOrderQuote)({
                contractNumber: contractNo
              }).then(function (quoteRes) {
                if (quoteRes.code === 200 && quoteRes.data) {
                  var total = _this12.calcQuoteTotal(quoteRes.data);

                  if (_this12.payInfo.chargeAmount == null) {
                    _this12.payInfo.chargeAmount = Number(total.toFixed(2));
                  }
                }
              }).catch(function () {});
            }
          }
        } else {
          _this12.$message.error(response && response.msg || '加载付款信息失败');
        }
      }).catch(function () {
        _this12.$message.error('加载付款信息失败');
      }).finally(function () {
        _this12.payLoading = false;
      });
    },
    // 确认付款
    handleConfirmPay: function handleConfirmPay() {
      var _this13 = this;

      // 已付款的不允许重复操作
      if (this.payInfo.payTime) {
        this.$message.warning('该订单已付款，无需重复操作');
        return;
      } // 付款金额必须已确认


      if (this.payInfo.chargeAmount == null) {
        this.$message.warning('请先确认报价金额（点击"查看报价"填入）');
        return;
      } // 付款金额为0时无需上传付款凭证


      if (Number(this.payInfo.chargeAmount) !== 0 && this.uploadPaymentProofs.length === 0) {
        this.$message.warning('请上传付款凭证');
        return;
      }

      this.$confirm('确认已付款？确认后付款信息将保存。', '确认付款', {
        confirmButtonText: '确认付款',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        // 弹窗确认后再填入付款人和付款时间
        var user = _this13.$store.getters.user || {};
        _this13.payInfo.payNickName = _this13.payInfo.payNickName || user.nickName || user.userName || '';
        _this13.payInfo.payTime = _this13.payInfo.payTime || _this13.formatNow();

        _this13.confirmPaySubmit();
      }).catch(function () {});
    },
    // 调用确认付款接口
    confirmPaySubmit: function confirmPaySubmit() {
      var _this14 = this;

      var rowId = this.payRowId;

      if (!rowId) {
        this.$message.warning('缺少改补信息ID');
        return;
      }

      this.paySubmitting = true;
      var data = {
        rowId: rowId,
        chargeAmount: this.payInfo.chargeAmount == null ? '' : this.payInfo.chargeAmount,
        paymentProof: this.uploadPaymentProofs || [],
        payNickName: this.payInfo.payNickName || '',
        payTime: this.payInfo.payTime || '',
        payRemark: this.payInfo.payRemark || ''
      };
      (0, _contract.subPay)(data).then(function (response) {
        if (response && response.code === 200) {
          _this14.$message.success('确认付款成功');

          _this14.showPayDialog = false; // 刷新列表

          _this14.handleSearch();
        } else {
          _this14.$message.error(response && response.msg || '确认付款失败');
        }
      }).catch(function (error) {
        console.error('确认付款失败:', error);

        _this14.$message.error('网络错误，请稍后重试');
      }).finally(function () {
        _this14.paySubmitting = false;
      });
    },
    // 格式化当前时间为 yyyy-MM-dd HH:mm:ss
    formatNow: function formatNow() {
      var d = new Date();

      var pad = function pad(n) {
        return n < 10 ? '0' + n : '' + n;
      };

      return "".concat(d.getFullYear(), "-").concat(pad(d.getMonth() + 1), "-").concat(pad(d.getDate()), " ").concat(pad(d.getHours()), ":").concat(pad(d.getMinutes()), ":").concat(pad(d.getSeconds()));
    },
    // 查看付款二维码
    handleViewPayQr: function handleViewPayQr() {
      this.showPayQrDialog = true;
    },
    // 打开报价信息弹窗
    handleOpenQuoteDialog: function handleOpenQuoteDialog() {
      var contractNo = this.payContractNo;

      if (!contractNo) {
        this.$message.warning('缺少合同号');
        return;
      }

      this.showQuoteDialog = true;
      this.loadQuoteData(contractNo);
    },
    // 加载报价信息
    loadQuoteData: function loadQuoteData(contractNumber) {
      var _this15 = this;

      this.quoteLoading = true;
      (0, _contract.getOrderQuote)({
        contractNumber: contractNumber
      }).then(function (response) {
        if (response.code === 200 && response.data) {
          _this15.quoteList = response.data;
          _this15.quoteTotal = _this15.calcQuoteTotal(response.data);
        } else {
          _this15.quoteList = [];
          _this15.quoteTotal = 0;
        }
      }).catch(function () {
        _this15.quoteList = [];
        _this15.quoteTotal = 0;

        _this15.$message.error('获取报价信息失败');
      }).finally(function () {
        _this15.quoteLoading = false;
      });
    },
    // 计算单个订单报价小计
    getQuoteTotal: function getQuoteTotal(quotes) {
      if (!quotes || quotes.length === 0) return 0;
      return quotes.reduce(function (sum, item) {
        return sum + (item.totalAmount || 0);
      }, 0);
    },
    // 计算报价合计（排除已取消订单）
    calcQuoteTotal: function calcQuoteTotal(list) {
      var _this16 = this;

      if (!list || list.length === 0) return 0;
      return list.reduce(function (sum, row) {
        if (row.productionStatus === '取消') return sum;
        return sum + _this16.getQuoteTotal(row.quotes);
      }, 0);
    },
    // 使用报价金额填入付款金额
    handleUseQuoteAmount: function handleUseQuoteAmount() {
      if (!this.canEditPay) {
        this.$message.warning('当前状态不可修改付款金额');
        return;
      }

      this.payInfo.chargeAmount = Number(this.quoteTotal.toFixed(2));
      this.showQuoteDialog = false;
      this.$message.success('已填入报价金额');
    },
    // 将付款凭证字符串转为上传列表回显（优先用完整url，兼容旧数据realName）
    buildUploadList: function buildUploadList(val) {
      var files = this.parseFiles(val);
      var prefix = this.$store.getters.imgPreviewPrefix || '';
      return files.map(function (item, index) {
        return {
          name: item.name || item.localName || item.alias || item.realName || '付款凭证' + (index + 1),
          url: item.url || prefix + (item.realName || ''),
          response: item,
          status: 'success'
        };
      });
    },
    // 解析文件 JSON 字符串
    parseFiles: function parseFiles(val) {
      if (!val) return [];

      try {
        var parsed = typeof val === 'string' ? JSON.parse(val) : val;
        if (!Array.isArray(parsed)) return [];
        return parsed.map(function (item) {
          if (typeof item === 'string') {
            try {
              return JSON.parse(item);
            } catch (_unused2) {
              return {
                realName: item
              };
            }
          }

          return item;
        });
      } catch (_unused3) {
        return [];
      }
    },
    // 生成凭证图片预览地址列表（优先用完整url，兼容旧数据realName）
    getPreviewList: function getPreviewList(val) {
      var files = this.parseFiles(val);
      var prefix = this.$store.getters.imgPreviewPrefix || '';
      return files.map(function (f) {
        return f.url || prefix + (f.realName || '');
      });
    },
    // 上传文件前校验
    handleBeforeUpload: function handleBeforeUpload(file) {
      var isLt100M = file.size / 1024 / 1024 < 100;

      if (!isLt100M) {
        this.$message.error('上传文件大小不能超过 100MB!');
        return false;
      }

      return true;
    },
    handleUploadSuccess: function handleUploadSuccess(type, response, file, fileList) {
      var pathStr = JSON.stringify(_objectSpread(_objectSpread({}, response), {}, {
        localName: file.name
      }));
      var listKey = type + 'UploadList';
      var dataKey = 'upload' + type.charAt(0).toUpperCase() + type.slice(1) + 's';
      this[listKey] = fileList;
      this[dataKey] = this[dataKey] || [];
      this[dataKey].push(pathStr);
    },
    // === 付款凭证 OSS 直传 ===
    // 触发付款凭证文件选择
    triggerPayProofUpload: function triggerPayProofUpload() {
      var input = this.$refs.payProofInput;
      if (!input) return;
      input.click(); // 延迟重置 value，使同一文件可再次选择

      setTimeout(function () {
        input.value = '';
      }, 50);
    },
    // 选择付款凭证文件后逐个 OSS 直传
    handlePayProofFileChange: function handlePayProofFileChange(e) {
      var files = e.target.files;
      if (!files || files.length === 0) return;

      for (var i = 0; i < files.length; i++) {
        this.uploadPayProofToOss(files[i]);
      }
    },
    // OSS 直传单个付款凭证（走 /api/oss/policy 获取凭证后直传 OSS，避免 /api/oss/upload 404）
    uploadPayProofToOss: function uploadPayProofToOss(rawFile) {
      var _this17 = this;

      // 大小校验
      if (rawFile.size / 1024 / 1024 > 100) {
        this.$message.error("\u6587\u4EF6\u300C".concat(rawFile.name, "\u300D\u5927\u5C0F\u4E0D\u80FD\u8D85\u8FC7 100MB"));
        return;
      }

      this.payProofUploading = true;
      (0, _ossUpload.getOssPolicy)().then(function (policyData) {
        var formData = new FormData(); // 图片凭证放 upload/image/ 目录

        var key = 'upload/image/' + _this17.generateObjectKey(rawFile.name);

        formData.append('key', key);
        formData.append('OSSAccessKeyId', policyData.accessKeyId);
        formData.append('policy', policyData.policy);
        formData.append('signature', policyData.signature); // STS 临时凭证需要附加 securityToken

        if (policyData.securityToken) {
          formData.append('x-oss-security-token', policyData.securityToken);
        } // 让 OSS 返回 200，避免解析 XML


        formData.append('success_action_status', '200');
        formData.append('file', rawFile);
        var xhr = new XMLHttpRequest();
        xhr.open('POST', policyData.host, true);
        xhr.addEventListener('load', function () {
          _this17.payProofUploading = false;

          if (xhr.status === 200 || xhr.status === 204) {
            var fileUrl = "".concat(policyData.host, "/").concat(key);
            var fileInfo = {
              realName: key,
              url: fileUrl,
              name: rawFile.name,
              localName: rawFile.name,
              size: rawFile.size,
              type: '图片'
            }; // 加入展示列表

            _this17.paymentProofUploadList.push({
              uid: Date.now() + '_' + Math.random().toString(36).substr(2, 8),
              name: rawFile.name,
              url: fileUrl,
              response: fileInfo,
              status: 'success'
            }); // 加入提交列表


            _this17.uploadPaymentProofs.push(JSON.stringify(fileInfo));

            _this17.$message.success('上传成功');
          } else {
            // 解析 OSS XML 错误
            var ossCode = '';
            var ossMsg = '';

            try {
              var parser = new DOMParser();
              var xml = parser.parseFromString(xhr.responseText, 'text/xml');
              var codeEl = xml.querySelector('Code');
              var msgEl = xml.querySelector('Message');
              ossCode = codeEl ? codeEl.textContent : '';
              ossMsg = msgEl ? msgEl.textContent : '';
            } catch (e) {}

            var errMsg = ossCode ? "\u4E0A\u4F20\u5931\u8D25 [".concat(ossCode, "] ").concat(ossMsg) : "\u4E0A\u4F20\u5931\u8D25\uFF0C\u72B6\u6001\u7801: ".concat(xhr.status);
            console.error('OSS 直传失败:', xhr.status, xhr.responseText);

            _this17.$message.error(errMsg);
          }
        });
        xhr.addEventListener('error', function () {
          _this17.payProofUploading = false;

          _this17.$message.error('网络错误，上传失败');
        });
        xhr.send(formData);
      }).catch(function (err) {
        _this17.payProofUploading = false;
        console.error('获取 OSS 上传凭证失败:', err);

        _this17.$message.error('获取 OSS 上传凭证失败');
      });
    },
    // 生成 OSS 对象键（时间戳 + 随机串 + 扩展名，避免文件名冲突）
    generateObjectKey: function generateObjectKey(fileName) {
      var timestamp = Date.now();
      var random = Math.random().toString(36).substr(2, 8);
      var ext = fileName.substring(fileName.lastIndexOf('.'));
      return timestamp + '_' + random + ext;
    },
    // 上传失败提示
    handleUploadError: function handleUploadError(type, err, file) {
      console.error('上传失败:', type, err);
      var msg = '上传失败，请稍后重试';

      if (err && err.status) {
        if (err.status === 401) msg = '上传失败：登录已过期，请重新登录';else if (err.status === 413) msg = '上传失败：文件过大';else msg = '上传失败：HTTP ' + err.status;
      }

      this.$message.error(msg);
    },
    handleUploadRemove: function handleUploadRemove(type, file) {
      var listKey = type + 'UploadList';
      var dataKey = 'upload' + type.charAt(0).toUpperCase() + type.slice(1) + 's';
      this[listKey] = this[listKey].filter(function (f) {
        return f.uid !== file.uid;
      });
      var targetName = file.response ? file.response.realName : '';

      if (targetName) {
        this[dataKey] = this[dataKey].filter(function (item) {
          try {
            var o = JSON.parse(item);
            return o.realName !== targetName;
          } catch (_unused4) {
            return true;
          }
        });
      } else {
        // 如果 file.response 不存在，用文件名匹配过滤
        this[dataKey] = this[dataKey].filter(function (item) {
          try {
            var o = JSON.parse(item);
            return o.localName !== file.name;
          } catch (_unused5) {
            return true;
          }
        });
      }
    }
  }
};
exports.default = _default;